import { Link } from "react-router-dom";
import PageHeader from "../shared/PageHeader";

export default function PartnerPrivacyPolicy() {
  return (
    <div className="container page-navbar-space">
      <PageHeader>Partner Privacy Policy</PageHeader>
      <div
        className="mt-4"
        style={{ maxWidth: "900px", color: "#444", lineHeight: "1.7" }}
      >
        <p className="size-16 fw-normal">
          This policy describes how Ownfood collects, uses, and protects data
          provided by partners, including sellers and business collaborators on
          the platform.
        </p>
        <p className="size-16 fw-normal">
          Partner data is used to support account operations, order management,
          payments, compliance, and service quality improvements.
        </p>
        <p className="size-16 fw-normal mb-4">
          If you need assistance regarding partner data handling, please reach
          out through the{" "}
          <Link to="/contact-us" className="text-decoration-none">
            Contact Us
          </Link>{" "}
          page.
        </p>
      </div>
    </div>
  );
}
